<template>
  <div class="emsBreadcrumb">
    <a-breadcrumb class="emsBreadcrumb-breadcrumb" separator=">">
      <a-breadcrumb-item v-for="(item ,key) in data" :key="key">
        <span v-if="key == data.length-1" class="pointer">{{ item.name }}</span>
        <span v-else class="pointer" @click="$router.push(item.path)">{{ item.name }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
.emsBreadcrumb {
  .pointer {
    cursor: pointer;
  }
  &-breadcrumb {
    font-size: 16px;
    color: #666;
    & > :last-child {
      color: #222;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/component/emsBreadcrumb.vue